export const DELETE_DOCUMENT_SUCCESS = 'DELETE_DOCUMENT_SUCCESS';

export const deleteDocumentSuccess = (id) => ({
    type: DELETE_DOCUMENT_SUCCESS,
    payload: { id },
});
